import { storeToRefs } from 'pinia'
import { watch } from 'vue'
import { useDeviceManagementPrinterStatusStore } from '@nsftx/seven-client-retail-vue-dm'
import {
  handlePrinterStatusChange,
  showPrinterStatusErrorNotification
} from '@/modules/print/services/printerStatusService'

const usePrinterStatus = () => {
  const { printerStatus } = storeToRefs(useDeviceManagementPrinterStatusStore())

  if (!printerStatus.value.valid) {
    showPrinterStatusErrorNotification()
  }

  watch(printerStatus, handlePrinterStatusChange)
}

export { usePrinterStatus }
